export class ChapterGraphModel {
  nodes?: Array<{ id: string; displayName: string }>;
  root?: {
    children?: string[];
    replace?: boolean;
  };
  connect?: {
    [key: string]: {
      children?: string[];
      replace?: boolean;
    };
  };
  terminal?: string[];
}
